import React from 'react'
import { Link } from 'react-router-dom'
import { Navbar, Footer } from '../components/SharedLayout'
import { ArrowRight } from 'lucide-react'

const colors = {
  teal: '#145F6B',
}

const articles = [
  {
    title: 'Iowa Luxury Homeowners',
    description: 'Ideas and perspective for maintaining high-value homes in the Des Moines metro.',
    to: '/blog/iowa-luxury',
  },
  {
    title: 'Proactive Maintenance Guide',
    description: 'How proactive care protects your home and your time.',
    to: '/blog/proactive-maintenance',
  },
]

const HomeInsightsPage: React.FC = () => (
  <div className="min-h-screen bg-white">
    <Navbar />
    <main className="pt-24 lg:pt-28 pb-20">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12">
        <h1 className="font-serif text-grey-900" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: 1.1, letterSpacing: '-0.02em' }}>
          Home Insights
        </h1>
        <p className="mt-4 text-lg text-grey-600 max-w-2xl">
          Articles and guides from Hudson My Home™ on caring for your home with confidence.
        </p>
        <ul className="mt-12 space-y-6">
          {articles.map((a) => (
            <li key={a.to}>
              <Link
                to={a.to}
                className="group block rounded-xl border border-grey-200 p-6 lg:p-8 hover:border-grey-300 transition-colors"
              >
                <h2 className="font-serif text-xl lg:text-2xl text-grey-900 group-hover:text-grey-700">{a.title}</h2>
                <p className="mt-2 text-grey-600">{a.description}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-[15px] font-medium" style={{ color: colors.teal }}>
                  Read article
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </main>
    <Footer />
  </div>
)

export default HomeInsightsPage
